// Facebook, Google and Bing/Microsoft Ads click-id params.
const AD_CLICK_ID_PARAMS = ["fbclid", "gclid", "msclkid"];
const AMBASSADOR_ORIGIN_PARAM = "o";

const TOGGLE_BAN_STATUS_ENDPOINT =
  "https://waalaxy-website-vert.vercel.app/api/toggle-ambassador-ban-status";

const SESSION_STORAGE_KEY_PREFIX = "amb_ad_affiliation_reported_";

// Waalaxy's own ad tracking codes also flow through o=, prefixed with "ads-" —
// those aren't ambassador affiliation codes and must not be reported.
const OWN_ADS_CODE_PREFIX = "ads-";

const getAmbassadorAdAffiliationCode = (): string | null => {
  const params = new URLSearchParams(window.location.search);
  const hasAdClickId = AD_CLICK_ID_PARAMS.some((param) => params.has(param));
  const ambCode = params.get(AMBASSADOR_ORIGIN_PARAM);
  if (!hasAdClickId || !ambCode) return null;
  if (ambCode.toLowerCase().startsWith(OWN_ADS_CODE_PREFIX)) return null;
  return ambCode;
};

// An ambassador running paid ads under their own affiliation code breaks the
// program rules, so we flag it to palpatine-back via a Vercel serverless proxy
// (keeps the admin token off the client). Reported at most once per ambCode per
// browser session, since the backend route toggles the ban status.
export const reportAmbassadorAdAffiliation = async (): Promise<void> => {
  const ambCode = getAmbassadorAdAffiliationCode();
  if (!ambCode) return;

  const sessionKey = `${SESSION_STORAGE_KEY_PREFIX}${ambCode}`;
  if (sessionStorage.getItem(sessionKey)) return;
  sessionStorage.setItem(sessionKey, "1");

  try {
    const response = await fetch(TOGGLE_BAN_STATUS_ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ambCode })
    });

    if (!response.ok) throw new Error(`HTTP error: ${response.status}`);

    posthog?.capture("ambassador_ad_affiliation_detected", { amb_code: ambCode });
  } catch (error) {
    console.error("Error reporting ambassador ad affiliation", error);
  }
};
